var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('svg',{staticClass:"icon",class:( _obj = {}, _obj[("icon-" + (_vm.props.name))] = true, _obj )},[_c('use',{attrs:{"xlink:href":("#icon-" + (_vm.props.name))}})])}
var staticRenderFns = []

export { render, staticRenderFns }